import { Dispatch } from 'redux';
import { connect } from 'react-redux';
import { DispatchProps, OwnProps, StateProps } from './ServiceLocationEditScreen';
import ServiceTypeEdit from './ServiceLocationEditScreen';
import { StoreState } from 'src/store/reducers';
import { getServiceLocation } from 'src/store/actions/service-location-actions';

function mapStateToProps(state: StoreState, ownProps: OwnProps): StateProps {
    return {
        serviceLocation: state.serviceLocations.current,
        inProgress: state.serviceLocations.inProgress,
    };
}
function mapDispatchToProps(dispatch: Dispatch, ownProps: OwnProps): DispatchProps {
    return {
        getData: (id) => dispatch(getServiceLocation(id)),
    };
}

const ServiceTypeEditScreen = connect<StateProps, DispatchProps, OwnProps, StoreState>(
    mapStateToProps,
    mapDispatchToProps,
)(ServiceTypeEdit);

export default ServiceTypeEditScreen;
